import { render, staticRenderFns } from "./accepted-table.vue?vue&type=template&id=6f8284ef&scoped=true&"
import script from "./accepted-table.vue?vue&type=script&lang=js&"
export * from "./accepted-table.vue?vue&type=script&lang=js&"
import style0 from "./accepted-table.vue?vue&type=style&index=0&id=6f8284ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8284ef",
  null
  
)

export default component.exports